var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('d2-container',[_c('h2',[_vm._v("企业资料审阅")]),_c('ReviewComponents',{attrs:{"activeName":_vm.activeName}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }